import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/home.jpg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              MEET THE <span className="purple">DEVELOPER</span> IN <span className="purple">ACTION</span>
            </h1>
            <h3 style={{ fontWeight: 400, marginTop: "0.5em", fontSize: "1.5em" }}>
              Building <span className="purple">ideas</span> through <span className="purple">code</span>
            </h3>
            <p className="home-about-body">
              I’m a <span className="purple">CS undergraduate</span> focused on building reliable and scalable <span className="purple">software solutions</span>, with a strong foundation in problem-solving and core computer science concepts.
              <br /><br />
              My experience includes <span className="purple">full-stack web development</span>, <span className="purple">RESTful APIs</span>, and database-driven systems, with an emphasis on performance and scalability.
              <br /><br />
              I work with <span className="purple">JavaScript</span>, <span className="purple">Java</span>, <span className="purple">C++</span>, and <span className="purple">Python</span>, and have hands-on experience using <span className="purple">React.js</span> and <span className="purple">Node.js</span> across both frontend and backend layers.
              <br /><br />
              I’m particularly interested in building <span className="purple">web and mobile-based applications</span>, working with <span className="purple">API-driven features</span>, and exploring <span className="purple">cloud-based deployments.</span>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
